document.addEventListener('DOMContentLoaded', function() {
  const stickers = [
    {
      afterSection: 'shopify-section-template--20755823919298__marquee_slider_RahfEz',
      cls: 'sticker--shell',
      src: 'https://cdn.shopify.com/s/files/1/0749/9861/2162/files/3_39f109ce-f71f-4bb1-a0ea-341ff326caba.png?v=1780635040',
      speed: 0.15,
      zIndex: null
    },
    {
      afterSection: 'shopify-section-template--20755823919298__featured_collection',
      cls: 'sticker--plate',
      src: 'https://cdn.shopify.com/s/files/1/0749/9861/2162/files/4_409e6cd8-4c9c-433a-8605-dc06b0e81495.png?v=1780635040',
      speed: 0.2,
      zIndex: null
    },
    {
      afterSection: 'shopify-section-template--20755823919298__featured_collection_Xmkz9W',
      cls: 'sticker--cutlery',
      src: 'https://cdn.shopify.com/s/files/1/0749/9861/2162/files/5_62d066b8-ac58-45fb-8085-a595689b83bb.png?v=1780635040',
      speed: 0.18,
      zIndex: null
    },
    {
      afterSection: 'shopify-section-template--20755824017602__image_banner_DJxe7G',
      cls: 'sticker--about-left',
      src: 'https://cdn.shopify.com/s/files/1/0749/9861/2162/files/6.png?v=1780651116',
      speed: 0.15,
      zIndex: 2
    },
    {
      afterSection: 'shopify-section-template--20755824017602__image_banner_DJxe7G',
      cls: 'sticker--about-right',
      src: 'https://cdn.shopify.com/s/files/1/0749/9861/2162/files/7.png?v=1780651116',
      speed: 0.2,
      zIndex: 2
    },
  ];

  // 插入 sticker DOM
  stickers.forEach(({ afterSection, cls, src, speed, zIndex }) => {
    const section = document.getElementById(afterSection);
    if (!section) return;
    const wrap = document.createElement('div');
    wrap.className = 'sticker-wrap';
    if (zIndex) wrap.style.zIndex = zIndex;
    const img = document.createElement('img');
    img.src = src;
    img.className = cls;
    img.alt = '';
    img.dataset.speed = speed;
    wrap.appendChild(img);
    section.appendChild(wrap);
  });

  // Parallax scroll
  window.addEventListener('scroll', function() {
    const scrollY = window.scrollY;
    document.querySelectorAll('.sticker-wrap img').forEach(img => {
      const wrap = img.closest('.sticker-wrap');
      const wrapTop = wrap.getBoundingClientRect().top + scrollY;
      const speed = parseFloat(img.dataset.speed || 0.15);
      const offset = (scrollY - wrapTop) * speed;
      img.style.transform = `translateY(${offset}px)`;
    });
  });
});

// 等頁面完全載入後才改，包含 section JS 跑完
window.addEventListener('load', function() {
  setTimeout(function() {
    document.querySelectorAll('svg text, svg textPath').forEach(el => {
      el.setAttribute('font-family', 'english');
    });
  }, 500);
});